import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Send } from 'lucide-react';
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { useAiStarterSuggestions } from '@Hooks/useAiChats';
import { SuggestionPills, SuggestionPillsSkeleton } from '@Components/SuggestionPills';

export default function AiChatBar({ currentAgent }) {
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const soulId = currentAgent?.id;
  const { data: suggestions, isLoading: suggestionsLoading } = useAiStarterSuggestions({
    soulId,
    enabled: !!soulId,
  });

  const handleSubmit = (text?: string) => {
    const trimmed = (text ?? message).trim();
    if (!trimmed) return;
    navigate(`/ai-chat`, {
      state: {
        initialMessage: trimmed,
        soulId,
      },
    });
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') handleSubmit();
  };

  return (
    <div className="flex w-full max-w-[60%] flex-col gap-3">
      <div className="flex items-center gap-2 rounded-4xl border bg-white px-4 py-3 shadow-sm">
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="What do you need help with?"
          className="min-w-0 flex-1 bg-transparent text-sm text-zinc-900 placeholder:text-zinc-400 focus:outline-none"
        />
        <Button
          onClick={() => handleSubmit()}
          disabled={!message.trim()}
          size="icon"
          className="shrink-0 rounded-4xl"
        >
          <Send className="h-4 w-4" />
        </Button>
      </div>

      <div className="min-h-6.5 px-1">
        {suggestionsLoading ? (
          <SuggestionPillsSkeleton />
        ) : (
          <SuggestionPills
            suggestions={suggestions ?? []}
            onPick={(prompt) => handleSubmit(prompt)}
          />
        )}
      </div>
    </div>
  );
}
